"use strict";var _this=this;Object.defineProperty(exports,"__esModule",{value:!0}),exports.off=exports.on=void 0;var weex_1=require("./weex"),on=function(e,o){weex_1.requireModule("globalEvent").addEventListener(e,function(e){var t={preventDefault:function(){throw new Error("does not support preventDefault")},detail:e};o.call(_this,t)})};exports.on=on;var off=function(e,o){weex_1.requireModule("globalEvent").removeEventListener(e,o)};exports.off=off;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_dingtalk-jsapi@2.13.50@dingtalk-jsapi/lib/bridge/weexEvent.js
// module id = eyGj
// module chunks = 0